export function useConfigurationAPI() {
  const { errors, request } = useRequest();

  async function getSiteConfiguration() {
    const url = versionedUrl('Configuration/SiteConfiguration');

    return await request<SiteConfiguration>(url);
  }

  async function getUserConfiguration() {
    const url = versionedUrl('Configuration/UserConfiguration');

    return await request<UserConfiguration>(url);
  }

  async function getUnits() {
    const url = versionedUrl('Configuration/GetUnits');

    return await request<Unit[]>(url);
  }

  async function getBankHolidays() {
    const url = versionedUrl('Configuration/GetBankHolidays');

    return await request<BankHoliday[]>(url);
  }

  async function UpsertLocale(locale: UserLocale) {
    const url = versionedUrl('Configuration/UpsertLocale');
    const requestOptions: RequestOptions = {
      method: 'post',
      body: locale
    };

    return await request<number>(url, requestOptions);
  }

  return {
    errors,
    getUserConfiguration,
    getSiteConfiguration,
    getUnits,
    getBankHolidays,
    UpsertLocale
  };
}
